// Ambient videos (snippets/video.liquid, [data-autoplay]): play only while on screen,
// never under prefers-reduced-motion (poster stays). [data-restart] rewinds on each entry.
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

const io = new IntersectionObserver((entries) => {
  for (const e of entries) {
    const v = e.target;
    if (e.isIntersecting && !reduce.matches && !v.hasAttribute('data-paused')) {
      if (v.hasAttribute('data-restart')) v.currentTime = 0;
      v.muted = true;
      v.play().catch(() => {});
    } else {
      v.pause();
    }
  }
}, { rootMargin: '100px 0px' });

const watch = (root = document) => root.querySelectorAll('video[data-autoplay]').forEach((v) => io.observe(v));

watch();
document.addEventListener('shopify:section:load', (e) => watch(e.target));
const reobserve = () => document.querySelectorAll('video[data-autoplay]').forEach((v) => { io.unobserve(v); io.observe(v); });
document.addEventListener('film:closed', reobserve);
reduce.addEventListener('change', () => {
  document.querySelectorAll('video[data-autoplay]').forEach((v) => { io.unobserve(v); io.observe(v); });
});
